import { render, staticRenderFns } from "./rights.vue?vue&type=template&id=52e6e4ec&scoped=true"
import script from "./rights.vue?vue&type=script&lang=js"
export * from "./rights.vue?vue&type=script&lang=js"
import style0 from "../college/logo-layout.css?vue&type=style&index=0&id=52e6e4ec&prod&scoped=true&lang=css&external"
import style1 from "./rights.vue?vue&type=style&index=1&id=52e6e4ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e6e4ec",
  null
  
)

export default component.exports